import {
  SearchResultCardView,
  QuizCardView,
  BudgetQuizCardView,
  MiniQuizCardView,
} from '../SearchResults/types/types';

export const BUDGET_QUIZ_CARD: BudgetQuizCardView = { type: 'quiz', name: 'Budget quiz' };
export const MINI_QUIZ_CARD: MiniQuizCardView = { type: 'quiz', name: 'Mini quiz' };

export const isQuizCardView = (card: SearchResultCardView): card is QuizCardView =>
  'type' in card && card.type === 'quiz';

export const isMiniQuizCardView = (card: SearchResultCardView): card is MiniQuizCardView => {
  return isQuizCardView(card) && card.name === 'Mini quiz';
};
export const isBudgetQuizCardView = (card: SearchResultCardView): card is BudgetQuizCardView => {
  return isQuizCardView(card) && card.name === 'Budget quiz';
};
